import { render } from "./HandOffOwnershipDialog.vue?vue&type=template&id=b1864b08"
import script from "./HandOffOwnershipDialog.vue?vue&type=script&lang=js"
export * from "./HandOffOwnershipDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__